import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const StudentsPresignupAutoLoginScreen = () => {
    const navigate = useNavigate();
    useEffect(() => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/signup/login/existing',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                tk:string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    else if(d.reason === 'not-found'){
                        ShowSnackbar('امکان پیش ثبت‌نام هنوز برای شما فعال نشده است.','باشه',5000);
                        navigate('/students/overview',{replace:true});
                    }
                    return;
                }
                localStorage.setItem('signupAuth', d.tk);
                navigate('/signup/status', {replace: true});
            },
            () => {
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    }, []);
    return (
        <>

        </>
    );
};